export type LoadingSkeletonSurface =
  | "consoleDashboard"
  | "tenantWorkspace"
  | "savedViews"
  | "reviewerInbox"
  | "autonomySettings"
  | "loadDetail"
  | "entityScorecard"
  | "agentTimeline"
  | "lanePreferences"
  | "trackingLink"
  | "carrierOffer"
  | "customerReport"
  | "podUpload"
  | "inviteAccept";

export interface LoadingSkeletonConfig {
  label: string;
  rows: number;
  columns: number;
}

export const LOADING_SKELETONS: Record<LoadingSkeletonSurface, LoadingSkeletonConfig> = {
  consoleDashboard: { label: "Loading dispatcher workspace", rows: 5, columns: 4 },
  tenantWorkspace: { label: "Loading tenant workspace", rows: 4, columns: 2 },
  savedViews: { label: "Loading saved views", rows: 4, columns: 3 },
  reviewerInbox: { label: "Loading reviewer inbox", rows: 6, columns: 4 },
  autonomySettings: { label: "Loading autonomy policies", rows: 6, columns: 5 },
  loadDetail: { label: "Loading load detail", rows: 5, columns: 3 },
  entityScorecard: { label: "Loading scorecard", rows: 3, columns: 5 },
  agentTimeline: { label: "Loading agent timeline", rows: 4, columns: 2 },
  lanePreferences: { label: "Loading lane preferences", rows: 3, columns: 2 },
  trackingLink: { label: "Loading tracking link", rows: 3, columns: 2 },
  carrierOffer: { label: "Loading carrier offer", rows: 4, columns: 2 },
  customerReport: { label: "Loading customer report", rows: 3, columns: 5 },
  podUpload: { label: "Loading POD link", rows: 3, columns: 1 },
  inviteAccept: { label: "Loading invite", rows: 4, columns: 1 },
};

export function getLoadingSkeleton(surface: LoadingSkeletonSurface): LoadingSkeletonConfig {
  return LOADING_SKELETONS[surface];
}
